import React, { useMemo } from 'react'

import Separator from '../../../../../components/pdf/Separator'
import Text from '../../../../../components/pdf/Text'
import View from '../../../../../components/pdf/View'
import Image from '../../../../../components/pdf/Image'

import { getImages, findReplyByQuestionName, getReplyValue } from '../../_helpers/pdfHelpers'

const AttachmentsSection = ({ certify }) => {
  const certifyImages = useMemo(() => {
    if (!certify || !certify.length) {
      return []
    }

    const reply = getReplyValue(findReplyByQuestionName(certify[0].replies, 'Qual o tipo de equipamento?'))
    if (reply.name === 'Outros') {
      const temperatura = getImages(
        findReplyByQuestionName(certify[0].replies, 'Temperatura e umidade - Incluir imagem do certificado [foto]')
      )
      const iluminancia = getImages(
        findReplyByQuestionName(certify[0].replies, 'Iluminância - Incluir imagem do certificado [foto]')
      )
      const ruido = getImages(
        findReplyByQuestionName(certify[0].replies, 'Ruído - Incluir imagem do certificado [foto]')
      )
      return [ruido[0], iluminancia[0], temperatura[0]]
    }
    return getImages(findReplyByQuestionName(certify[0].replies, 'Incluir imagem do certificado'))
  }, [certify])

  return (
    <View id="8">
      <View>
        <Text bold size="small" id={'8'}>
          8 ANEXOS
        </Text>
        <Text bold align={'center'} id={'8.1'}>
          ANEXO I – CERTIFICADOS DE CALIBRAÇÃO DOS EQUIPAMENTOS
        </Text>
        <>
          {certifyImages.length ? (
            certifyImages.map((image, index) => (
              <Image style={{ margin: 'auto' }} maxHeight={850} key={index} src={image.src} ignoreFixedSize />
            ))
          ) : (
            <Text align={'center'}>Não encontrado</Text>
          )}
        </>
      </View>
      <Separator weight={8} />
    </View>
  )
}
export default AttachmentsSection
